/* Soil & Oil: tek seferlik dil önerisi (İngilizce, Rusça).
 * Cihazın ilk dili desteklenen bir dilse ve listede hiç tr yoksa, Türkçe sayfada o dili sade bir seçimle önerir.
 * Seçim veya kapatma hatırlanır; İngilizce ya da Rusça sayfayı açan ziyaretçi de seçim yapmış sayılır.
 * İşaretleme: snippets/language-suggestion.liquid. */
(function (root) {
  var STORAGE_KEY = 'soil_lang_choice';
  var TARGETS = ['en', 'ru'];
  var BOT = /bot|crawl|spider|slurp|lighthouse|headless|facebookexternalhit|preview|inspection/i;

  function base(lang) { return String(lang || '').toLowerCase().split('-')[0]; }

  // Önerilecek dil kodu ('en' | 'ru') ya da null.
  function suggestTarget(o) {
    if (o.choice) return null;
    if (o.locale !== 'tr') return null;
    if (o.webdriver || BOT.test(o.userAgent || '')) return null;
    var langs = (o.languages || []).map(base);
    if (!langs.length) return null;
    for (var i = 0; i < langs.length; i++) if (langs[i] === 'tr') return null;
    var first = langs[0];
    var alternates = o.alternates || {};
    return TARGETS.indexOf(first) !== -1 && alternates[first] ? first : null;
  }

  function buildTargetUrl(href, search, hash) {
    var extra = (search || '').replace(/^\?/, '');
    var url = href;
    if (extra) url += (url.indexOf('?') === -1 ? '?' : '&') + extra;
    return url + (hash || '');
  }

  function read(win) {
    try { return win.localStorage.getItem(STORAGE_KEY); } catch (e) { return undefined; }
  }
  function write(win, value) {
    try { win.localStorage.setItem(STORAGE_KEY, value); return true; } catch (e) { return false; }
  }

  function alternatesOf(doc) {
    var out = {};
    var links = doc.querySelectorAll('link[rel="alternate"][hreflang]');
    for (var i = 0; i < links.length; i++) {
      var code = String(links[i].hreflang || links[i].getAttribute && links[i].getAttribute('hreflang') || '').toLowerCase();
      if (TARGETS.indexOf(code) !== -1) out[code] = links[i].href;
    }
    return out;
  }

  function init(doc, win) {
    var box = doc.querySelector('[data-soil-lang]');
    if (!box) return;
    var locale = box.getAttribute('data-locale');
    var choice = read(win);
    if (choice === undefined) return; // depolama yoksa seçim hatırlanamaz, gösterme
    if (TARGETS.indexOf(locale) !== -1) { if (!choice) write(win, locale); return; }
    var alternates = alternatesOf(doc);
    var nav = win.navigator || {};
    var target = suggestTarget({
      languages: nav.languages && nav.languages.length ? nav.languages : [nav.language],
      userAgent: nav.userAgent, webdriver: nav.webdriver === true,
      locale: locale, choice: choice, alternates: alternates
    });
    if (!target) return;
    var texts = box.querySelectorAll('[data-soil-lang-text]');
    for (var i = 0; i < texts.length; i++) texts[i].hidden = texts[i].getAttribute('data-soil-lang-text') !== target;
    function close(value) { write(win, value); box.hidden = true; }
    box.querySelector('[data-soil-lang-go]').addEventListener('click', function () {
      write(win, target);
      win.location.assign(buildTargetUrl(alternates[target], win.location.search, win.location.hash));
    });
    box.querySelector('[data-soil-lang-tr]').addEventListener('click', function () { close('tr'); });
    box.querySelector('[data-soil-lang-close]').addEventListener('click', function () { close('dismissed'); });
    box.hidden = false;
  }

  root.SoilLanguageSuggestion = { STORAGE_KEY: STORAGE_KEY, suggestTarget: suggestTarget, buildTargetUrl: buildTargetUrl, init: init };
  if (root.document) {
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', function () { init(root.document, root); });
    else init(root.document, root);
  }
})(typeof window !== 'undefined' ? window : this);
